import { useState, useCallback, useMemo } from 'react';
import { getToolInstruction } from '../components/MarkupMode/types';
export const useMarkupMode = (options = {}) => {
    const { onActivate, onDeactivate } = options;
    const [activeTool, setActiveToolState] = useState(null);
    const setTool = useCallback((tool) => {
        setActiveToolState(prev => {
            const next = (tool === prev) ? null : tool;
            if (prev === null && next !== null) {
                onActivate === null || onActivate === void 0 ? void 0 : onActivate();
            }
            else if (prev !== null && next === null) {
                onDeactivate === null || onDeactivate === void 0 ? void 0 : onDeactivate();
            }
            return next;
        });
    }, [onActivate, onDeactivate]);
    const isActive = activeTool !== null;
    const instruction = useMemo(() => {
        if (!activeTool)
            return '';
        return getToolInstruction(activeTool);
    }, [activeTool]);
    return { activeTool, isActive, setTool, instruction };
};
